import * as React from 'react';

interface ITmpElementProps extends React.HTMLProps<HTMLDivElement> {
  content: string;
}

export const TmpElement = (props: ITmpElementProps) => {
  return <div className="tmp-container">{props.content || ''}</div>;
};
